import React, { FC, MouseEventHandler } from 'react'
import CustomButton from '../CustomButton';

export interface CustomModalHeaderProps {
    title: string;
    subtitle?: string;
    onClick: MouseEventHandler
}

const CustomModalHeader: FC<CustomModalHeaderProps> = ({
    title,
    subtitle,
    onClick
}) => {
    return (
        <div className='modal-header d-flex  align-items-center justify-content-between'>
            <div className='d-flex flex-column align-items-start fs-4 text-neutral-500 fw-semibold fs-custom-18px'>
                <div>{title}</div>
                {subtitle && <div className='fw-normal fs-custom-14px'>{subtitle}</div>}
            </div>
            <CustomButton variant='close' className='ms-2' onClick={onClick} />
        </div>
    )
}

export default CustomModalHeader